module.exports = __webpack_public_path__ + "static/media/example02-03.a3631aa9.svg";